import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import LoadingSpinner from "../global/LoadingSpinner";
import { getEmptyMotivators, useGetMotivators } from "../../hooks/motivators/Motivators";
import MotivatorsListItem from "./MotivatorsListItem";
import MotivatorsEditForm from "./MotivatorsEditForm";

function MotivatorsList() {
  const { t } = useTranslation();
  const { data, isLoading, isError, refetch } = useGetMotivators();
  const [isNew, setIsNew] = useState(false);
  const [newID, setNewID] = useState(null);

  const handleNew = () => {
    setIsNew(false); // Set isNew to false when onNew is called
    refetch();
  };

  const handleOnSave = () => {
    refetch();
    setIsNew(false);
  };

  if (isLoading) return <LoadingSpinner />;
  if (isError) return 'An error has occurred: ' + isError.message;

 // if(data) return <pre>{JSON.stringify(data ,null,2)}</pre>;
  return (
    <>
      {data.map((motivator, key) => {
        if (newID !== motivator.id)
          return <MotivatorsListItem key={key} id={motivator.id} data={motivator} onSave={handleOnSave} />;
        else return null;
      })}

      <div className="prizeGameAdmin-list prizeGameAdmin-listNew">
        {isNew ? (
          <div id="prizeGamenew">
            <MotivatorsEditForm id={null} data={getEmptyMotivators()} onNew={handleNew} onClose={handleNew} onSave={handleOnSave} />
          </div>
        ) : (
          <div onClick={() => setIsNew(true)}>
            <strong>{t("admin.prize.creM")}</strong>
            <em>{t("admin.prize.clkToC")}</em>
            <button className="btn btn-default btn-add" title={t("admin.common.add")} />
          </div>
        )}
      </div>
    </>
  );
}

export default MotivatorsList;
